/* unplugin-vue-components disabled */import script from "./mg-query-filter-form.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-query-filter-form.vue?vue&type=script&setup=true&lang=js"

import "./mg-query-filter-form.vue?vue&type=style&index=0&id=3c5ebd22&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c5ebd22"]])

export default __exports__